import React, { useEffect } from "react";

export default function Blog() {
  useEffect(() => {
    // SEO meta for the blog page
    const prev = document.title;
    document.title = "Fliboe FM — Blog & Insights";
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    meta?.setAttribute(
      "content",
      "Fliboe FM blog — internet radio tips, broadcaster guides, monetization playbooks, and station spotlights.",
    );

    // Inject Soro embed script (once)
    const id = "soro-embed-script";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = "https://app.trysoro.com/api/embed/d18e6f2a-0d67-4bb3-bfec-97af9d3a1b70";
      s.defer = true;
      document.body.appendChild(s);
    }

    return () => {
      document.title = prev;
      if (prevDesc) meta?.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <div className="min-h-[70vh] max-w-5xl mx-auto px-5 py-12" data-testid="blog-page">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-fuchsia-500/15 border border-fuchsia-400/30 text-fuchsia-200 text-xs font-semibold tracking-wide uppercase">
          Fliboe Journal
        </div>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white">
          Stories, signals & broadcaster playbooks.
        </h1>
        <p className="mt-3 text-white/60 max-w-2xl">
          The world of internet radio is moving fast. We share what&apos;s working — how broadcasters grow listeners,
          turn drops into tips, and ship a real show every week.
        </p>
      </div>

      {/* Soro embed mount point. Soro injects its own HTML; we force-readable
          colors on our near-black background via descendant selectors. */}
      <div
        id="soro-blog"
        data-testid="soro-blog-mount"
        className="soro-host rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur p-5 sm:p-8 min-h-[400px]"
      />

      <style>{`
        /* Force every text node inside the Soro embed to be readable on our dark theme. */
        .soro-host, .soro-host * {
          color: rgba(255,255,255,0.92) !important;
          background: transparent !important;
          border-color: rgba(255,255,255,0.10) !important;
        }
        .soro-host h1, .soro-host h2, .soro-host h3, .soro-host h4 {
          color: #fff !important;
          font-weight: 800 !important;
          letter-spacing: -0.01em;
          line-height: 1.2;
          margin-top: 1.4em;
          margin-bottom: 0.5em;
        }
        .soro-host h1 { font-size: 2rem; }
        .soro-host h2 { font-size: 1.5rem; }
        .soro-host h3 { font-size: 1.2rem; }
        .soro-host p, .soro-host li, .soro-host blockquote, .soro-host span, .soro-host div {
          color: rgba(255,255,255,0.82) !important;
          font-size: 1rem;
          line-height: 1.75;
        }
        .soro-host a {
          color: #10b981 !important;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .soro-host a:hover { color: #34d399 !important; }
        .soro-host strong, .soro-host b { color: #fff !important; font-weight: 700 !important; }
        .soro-host em, .soro-host i { color: rgba(255,255,255,0.92) !important; }
        .soro-host code, .soro-host pre {
          background: rgba(255,255,255,0.05) !important;
          color: #fde68a !important;
          border-radius: 6px;
          padding: 0.15em 0.4em;
          font-size: 0.9em;
        }
        .soro-host pre { padding: 1em; overflow-x: auto; }
        .soro-host blockquote {
          border-left: 3px solid #10b981 !important;
          padding-left: 1em;
          margin: 1.5em 0;
          font-style: italic;
          color: rgba(255,255,255,0.78) !important;
        }
        .soro-host ul, .soro-host ol { padding-left: 1.4em; margin: 1em 0; }
        .soro-host li { margin: 0.4em 0; }
        .soro-host img { border-radius: 12px; max-width: 100%; margin: 1.2em 0; }
        .soro-host hr { border-color: rgba(255,255,255,0.10) !important; margin: 2em 0; }
        .soro-host article, .soro-host section { padding: 0 !important; }
        /* Soro post cards (list view) */
        .soro-host [class*="card"], .soro-host article {
          background: rgba(255,255,255,0.03) !important;
          border: 1px solid rgba(255,255,255,0.08) !important;
          border-radius: 14px !important;
          padding: 1.25rem !important;
          margin-bottom: 1rem !important;
          transition: transform .15s ease, border-color .15s ease;
        }
        .soro-host [class*="card"]:hover, .soro-host article:hover {
          transform: translateY(-2px);
          border-color: rgba(245,158,11,0.45) !important;
        }
      `}</style>
    </div>
  );
}
